import React, { forwardRef } from 'react';
import { Row, Col } from 'antd';
import Input from './Input';
import Checkbox from './Checkbox';

const Price = forwardRef((props, ref) => {
  const {
    onChange,
    value,
    inputProps = {},
    checkboxProps = {},
    ...restProps
  } = props;

  const handleChange = (changedValue) => {
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  return (
    <Row
      {...restProps}
      gutter={16}
      ref={ref}
    >
      <Col span={14}>
        <Input
          {...inputProps}
          value={value.price}
          onChange={handleChange}
        />
      </Col>
      <Col span={10}>
        <Checkbox
          {...checkboxProps}
          value={value.isNotFinal}
          onChange={handleChange}
        />
      </Col>
    </Row>
  );
});

export default Price;
